import Vue from 'vue'
import Router from 'vue-router'
import App from './app'
import Example from './example'
// import Ebiz from './ebiz'
import utils from '@/assets/js/business-common'

Vue.use(Router)

const constantRouterMap = [...App] //后续可以删减模块
const ALLOW_LIST = ['login']

// export default new Router({
//   mode: 'history', //路由模式
//   // base: process.env.BASE_URL,
//   // base: window.__POWERED_BY_QIANKUN__ ? '/sale' : process.env.BASE_URL, //qiankun
//   base: '/app/h5',
//   routes: constantRouterMap,
//   scrollBehavior: () => ({ y: 0 })
// })

let router = new Router({
  // mode: "history", //路由模式
  routes: constantRouterMap,
  base: '/app/h5/#/',
  scrollBehavior: () => ({ y: 0 })
})

// router.beforeEach((to, from, next) => {
// console.log('222--',to);
//   let token = utils.getCookie('token')
//   if (token != '' || ALLOW_LIST.includes(to.name)) {
//     next()
//   } else {
//     next({
//       path: '/',
//       query: {
//         redirect: to.fullPath
//       }
//     })
//   }
// })
export default router
